import {LOADER_TYPE} from '@advisor/util/constants';

export default {
  [LOADER_TYPE.CARD]: () => import('@advisor/components/common/loaders/Card'),
  [LOADER_TYPE.CARDSROW]: () => import('@advisor/components/common/loaders/CardsRow'),
  [LOADER_TYPE.CLIENTACCOUNTS]: () => import('@advisor/components/common/loaders/ClientAccounts'),
  [LOADER_TYPE.CLIENTGOALS]: () => import('@advisor/components/common/loaders/ClientGoals'),
  [LOADER_TYPE.CLIENTGRAPH]: () => import('@advisor/components/common/loaders/ClientGraph'),
  [LOADER_TYPE.CLIENTSUMMARYINFO]: () => import('@advisor/components/common/loaders/ClientSummaryInfo'),
  [LOADER_TYPE.CONTACTINFO]: () => import('@advisor/components/common/loaders/ContactInfo'),
  [LOADER_TYPE.DASHBOARDGRAPH]: () => import('@advisor/components/common/loaders/DashboardGraph'),
  [LOADER_TYPE.DASHBOARDLIST]: () => import('@advisor/components/common/loaders/DashboardList'),
  [LOADER_TYPE.GOALOVERVIEW]: () => import('@advisor/components/common/loaders/GoalOverview'),
  [LOADER_TYPE.GOALSUMMARY]: () => import('@advisor/components/common/loaders/GoalSummary'),
  [LOADER_TYPE.HEADING]: () => import('@advisor/components/common/loaders/Heading'),
  [LOADER_TYPE.MODELPORTFOLIO]: () => import('@advisor/components/common/loaders/ModelPortfolio'),
  [LOADER_TYPE.OPENACCOUNT]: () => import('@advisor/components/common/loaders/OpenAccount'),
  [LOADER_TYPE.OVERVIEW]: () => import('@advisor/components/common/loaders/Overview'),
  [LOADER_TYPE.TABLE]: () => import('@advisor/components/common/loaders/LoaderTable'),
  [LOADER_TYPE.STANDARD]: () => import('@advisor/components/common/loaders/Standard'),
  [LOADER_TYPE.WIDGET]: () => import('@advisor/components/common/loaders/svgShapes/Widget'),
  [LOADER_TYPE.WIDGETGROUP]: () => import('@advisor/components/common/loaders/WidgetGroup'),
  [LOADER_TYPE.CLIENTACCOUNTSEARCH]: () => import('@advisor/components/common/loaders/ClientAccountSearch'),
};
